import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail, fetchTreeList } from '@/api/system/menu/menu';
import { fetchListByType } from '@/api/system/dic/dic';
export default {
  data: function data() {
    return {
      targetOption: [{
        label: 'layout',
        value: 'layout'
      }, {
        label: 'url',
        value: 'url'
      }, {
        label: 'hidden',
        value: 'hidden'
      }],
      options: [],
      selectedMenuTypeList: [],
      menuTypes: [],
      menuUpId: [],
      rules: {
        menuName: [{
          required: true,
          message: '请输入菜单名称',
          trigger: 'blue'
        }, {
          min: 2,
          max: 50,
          message: '长度在 2 到 50 个字符',
          trigger: 'change'
        }],
        menuVirtualUrl: [{
          required: true,
          message: '请输入菜单虚拟地址',
          trigger: 'blue'
        }, {
          min: 1,
          max: 125,
          message: '长度在 1 到 125 个字符',
          trigger: 'change'
        }],
        // menuVueUrl: [{ required: true, message: '请输入菜单地址', trigger: 'blue' },
        //   { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'change' }
        // ],
        menuIcon: [{
          required: true,
          message: '请选择菜单图标',
          trigger: 'blue'
        }],
        menuVueTarget: [{
          required: true,
          message: '请选择菜单目标',
          trigger: 'blue'
        }],
        menuOrder: [{
          required: true,
          message: '请输入菜单排序',
          trigger: 'change'
        }]
      },
      propstree: {
        label: 'menuName',
        value: 'menuId',
        children: 'childMenu'
      },
      menuId: -1,
      childData: {}
    };
  },
  props: ['keyValue', 'showDialog'],
  created: function created() {
    this.init();
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs['dataForm'].resetFields();

        if (this.showDialog) {
          this.init();
        }
      }
    }
  },
  methods: {
    init: function init() {
      this.childData = {};
      this.options = [];
      this.menuUpId = [];
      this.selectedMenuTypeList = [];
      this.loadRoleTypes();
      this.loadMenuTree();
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          menuId: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          var list = [];

          _this.childData.upIdList.forEach(function (e) {
            list.push(e.toString());
          });

          _this.menuUpId = list;

          _this.menuTypes.forEach(function (e) {
            if ((parseInt(_this.childData.menuType) & parseInt(e.dicValue)) === parseInt(e.dicValue)) {
              _this.selectedMenuTypeList.push(e.dicValue);
            }
          });
        });
      } else {
        this.childData = {};
      }
    },
    // 获取角色类型
    loadRoleTypes: function loadRoleTypes() {
      var _this2 = this;

      fetchListByType('menu_type').then(function (r) {
        _this2.menuTypes = [];
        _this2.menuTypes = r.data.data;
      });
    },
    loadMenuTree: function loadMenuTree() {
      var _this3 = this;

      var treeQuery = {
        disabled: true
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this3.options = response.data.data;
      });
    },
    handCreate: function handCreate() {
      var _this4 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this4.selectedMenuTypeList.length === 0) {
            _this4.Alert({
              alertType: 'valid',
              message: '角色类型需至少选择一项！'
            });

            return;
          }

          _this4.childData.menuType = 0;
          console.log(_this4.selectedMenuTypeList);

          _this4.selectedMenuTypeList.forEach(function (e) {
            _this4.childData.menuType = _this4.childData.menuType + parseInt(e);
          });

          if (_this4.keyValue > 0) {
            _this4.childData.menuId = _this4.keyValue;
            _this4.childData.menuUpId = _this4.menuUpId[_this4.menuUpId.length - 1];

            if (_this4.childData.menuUpId === undefined) {
              _this4.childData.menuUpId = 0;
            }

            delete _this4.childData.upIdList;
            delete _this4.childData.isDel;
            fetchUpdate(_this4.childData).then(function () {
              _this4.$emit('handCancle', true);

              _this4.Alert({
                alertType: 'update'
              });
            });
          } else {
            if (_this4.menuUpId.length > 0) {
              _this4.childData.menuUpId = _this4.menuUpId[_this4.menuUpId.length - 1];
            } else {
              _this4.childData.menuUpId = 0;
            }

            _this4.childData.isDel = 0;
            fetchCreate(_this4.childData).then(function () {
              _this4.keyValue = -1;

              _this4.$emit('handCancle', true);

              _this4.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this4.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};